var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeofenceSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,10c-3.3085938,0-6,2.6914062-6,6s2.6914062,6,6,6s6-2.6914062,6-6S19.3085938,10,16,10z M16,20 c-2.2060547,0-4-1.7939453-4-4s1.7939453-4,4-4s4,1.7939453,4,4S18.2060547,20,16,20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,1C7.7285156,1,1,7.7285156,1,16s6.7285156,15,15,15s15-6.7285156,15-15S24.2714844,1,16,1z M16,29 C8.8320312,29,3,23.1679688,3,16S8.8320312,3,16,3s13,5.8320312,13,13S23.1679688,29,16,29z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofenceSmall);
export default __webpack_public_path__ + "static/media/geofence--small.8dbdd6e4f6f0faeb83bd0562b3ccbb5c.svg";
export { ForwardRef as ReactComponent };